<template
  xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
  xmlns:v-slot="http://www.w3.org/1999/XSL/Transform"
>
  <v-container fluid class="main-layout d-flex justify-center overflow-y-hidden">
    <Header
      :headerlogo-title="labels.ALT_IMAGES.ANALYZE_LOGO"
      :is-homepage="true"
      :add-bottom-border="true"
    />
    <v-snackbar
      v-model="displayAlertMsg.isShown"
      :timeout="
        displayAlertMsg.type === 'error'
          ? CONSTANTS.SNACKBAR_SUCCESS_TIMEOUT
          : CONSTANTS.SNACKBAR_ERROR_TIMEOUT
      "
      absolute
      location="bottom"
      center
      class="elevation-0"
      :color="CONSTANTS.ALERT_VIEW.COLOR"
      :min-width="CONSTANTS.ALERT_VIEW.MIN_WIDTH"
    >
    </v-snackbar>

    <div>
      <div :class="[displayAlertMsg.isShown ? 'margin-to-alert ' : 'mt-16 pt-8 ', 'center']">
        <h1 class="itemis-analyze-headline mb-3">
          {{ labels.HOMEPAGE.DETAILS.HOME_PAGE_TITLE }}
        </h1>
        <h3 class="itemis-analyze-title">
          {{ labels.HOMEPAGE.DETAILS.PRODUCT_DESCRIPTION }}
        </h3>
      </div>
      <div class="center pt-5">
        <v-btn
          data-testid="project-list-btn"
          color="info"
          :prepend-icon="CONSTANTS.ICONS_MDI.ICON_FOLDER_MULTIPLE"
          @click="navigate()"
        >
          {{ labels.PROJECT_LIST.PROJECT_LIST }}
        </v-btn>
      </div>

      <NewProjectDialog />
      <div class="marginHomePageBlock">
        <v-row>
          <v-col>
            <v-hover v-slot="{ isHovering, props }">
              <v-card
                v-bind="props"
                ref="createCard"
                :elevation="isHovering ? 10 : 3"
                hover
                data-test="createProject"
                data-testid="create-project-card"
                height="207"
                width="700"
                class="full-height"
                @click="openDialog"
              >
                <v-card-title class="center">
                  <p class="pt-2" style="font-size: 1.7rem; color: #1565c0; font-weight: bold">
                    {{ labels.HOMEPAGE.DETAILS.ADD_A_PROJECT_TITLE }}
                  </p>
                </v-card-title>
                <v-card-text class="full-height pa-6 d-flex flex-column">
                  <v-row class="align-center">
                    <v-col class="col" md="2"
                      ><v-img :src="'img/icons/CreateProject.svg'" width="100"></v-img
                    ></v-col>
                    <v-col class="col" md="10">{{
                      labels.HOMEPAGE.DETAILS.ADD_A_PROJECT_DESCRIPTION
                    }}</v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>

          <v-col>
            <v-hover v-slot="{ isHovering, props }">
              <v-card
                v-bind="props"
                class="full-height"
                :elevation="isHovering ? 10 : 3"
                hover
                data-testid="upload-snapshot-card"
                height="207"
                width="700"
                :loading="isSelecting"
                @click.stop="
                  () => {
                    snapshotUpload.click()
                  }
                "
              >
                <v-card-title class="center">
                  <p class="pt-2" style="font-size: 1.7rem; color: #1565c0; font-weight: bold">
                    {{ labels.HOMEPAGE.DETAILS.UPLOAD_SNAPSHOT_TITLE }}
                  </p>
                </v-card-title>
                <v-card-text class="full-height pa-6 d-flex flex-column">
                  <v-row class="align-center">
                    <v-col class="col" md="2"
                      ><v-img :src="'img/icons/uploadSnapshot.svg'" width="100"></v-img
                    ></v-col>
                    <v-col class="col" md="10">{{
                      labels.HOMEPAGE.DETAILS.UPLOAD_SNAPSHOT_DESCRIPTION
                    }}</v-col>
                  </v-row>
                </v-card-text>

                <input
                  id="fileUpload"
                  ref="snapshotUpload"
                  type="file"
                  class="d-none"
                  @change="handleFileImport"
                />
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<script lang="ts" setup>
  import labels from '@/translations/labels.json'
  import notifMessage from '@/translations/notifMessage.json'
  import CONSTANTS from '@/constants/Config.constants'
  import Header from '@/components/Header/Header.vue'
  import * as HELPERS from '@/utils/helpers'
  import { AlertData } from '@/models/alert-data.model'
  import NewProjectDialog from '@/components/NewProjectDialog/NewProjectDialog.vue'
  import { EventBus } from '@/event-bus'
  import { Project, Snapshot } from '@/models'
  import { onMounted, ref, watchEffect } from 'vue'
  import { useRouter } from 'vue-router'
  import { useSnapshotStore } from '@/stores/snapshotStore'
  import { useProjectStore } from '@/stores/projectStore'
  import { injectTyped } from '@/inject'
  import { ServiceKeys } from '@/services/symbols'

  const router = useRouter()
  const projectStore = useProjectStore()
  const snapshotStore = useSnapshotStore()

  const allowedFilesFormats = CONSTANTS.SNAPSHOT.ALLOWED_FORMATS
  const defaultProject = ref<Project>({
    ...new Project(),
    name: 'Uncategorized_' + HELPERS.RandomString(),
  })

  const uploadService = injectTyped(ServiceKeys.upload)
  const snapshotService = injectTyped(ServiceKeys.snapshot)
  const projectService = injectTyped(ServiceKeys.project)
  const snapshotUpload = ref()

  const isSelecting = ref(false)

  const selectedFile = ref<File>()
  const isHomePage = ref(false)
  const isUploading = ref(false)

  const displayAlertMsg = ref<AlertData>({
    type: 'error',
    message: '',
    isShown: false,
  })

  onMounted(() => {
    EventBus.on('cancelUploadFile', () => {
      HELPERS.showTopAlertMessage(false, 'error', '')
    })

    EventBus.on('projectCreatedSucessfull', () => {
      router.push({ name: labels.SIDEBAR.MAIN.PROJECT_LIST })

      HELPERS.showTopAlertMessage(true, 'success', notifMessage.SUCCESS_ALERTS.PROJECT_CREATED)
    })
  })
  watchEffect(() => {
    if (projectStore.projects.length > 0) {
      navigate()
    }
  })

  document.documentElement.style.overflowY = 'hidden'

  async function InitDefaultProject(file: File): Promise<void> {
    // initialise a default project for the Upload and pass it the upload file

    try {
      if (projectService && file) {
        const data = await projectService.createProject(defaultProject.value)
        defaultProject.value.id = data.id
        uploadSnapshot(file, defaultProject.value, isHomePage.value)
      }
    } catch {
      HELPERS.showTopAlertMessage(true, 'error', notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG)
    }
  }

  function navigate(): void {
    router.push(CONSTANTS.BASE_ROUTES.PROJECTLIST)
  }

  function uploadFile(file: File, isHomePage: boolean): void {
    if (isHomePage && HELPERS.hasValidExtension(file.name)) {
      if (file && HELPERS.hasValidExtension(file.name)) {
        InitDefaultProject(file)
      } else {
        HELPERS.showTopAlertMessage(true, 'error', buildFormatsMsg())
      }
    } else {
      HELPERS.showTopAlertMessage(true, 'error', buildFormatsMsg())
    }
  }

  async function uploadSnapshot(
    file: File,
    project: Project,
    isHomePage: boolean,
  ): Promise<void | Snapshot | undefined> {
    // upload the snapshot to the s3 bucket and display a success message
    if (!uploadService) {
      throw Error(notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG)
    }

    try {
      const presignedUrlObj = await uploadService.getPresignedUrl(project.id)
      await uploadService.uploadFileToAWSS3(presignedUrlObj.data.url, file)
      const notifyBackendResponse = await uploadService.notifyUploadSnapshotFinished(
        selectedFile.value?.name as string,
        project.id,
        presignedUrlObj.data.id,
      )
      if (isHomePage && !!notifyBackendResponse && !!snapshotService) {
        HELPERS.showTopAlertMessage(true, 'success', notifMessage.SUCCESS_ALERTS.SNAPSHOT_UPLOAD)

        redirectToProjectOverviewPage(project)

        snapshotStore.loadSnapshotsFromApi({
          projectId: project.id,
        })
      } else {
        goToProjectListPage()
      }
    } catch {
      HELPERS.showTopAlertMessage(true, 'error', notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG)
    }
  }
  function redirectToProjectOverviewPage(project: Project): void {
    isHomePage.value = false
    isSelecting.value = false
    projectStore.setCurrentProject(project)

    router.push({
      name: labels.SIDEBAR.MAIN.PROJECT_OVERVIEW,
      params: { projectId: projectStore.currentProject?.id.toString() },
    })
  }

  function goToProjectListPage(): void {
    router.push(CONSTANTS.BASE_ROUTES.PROJECTLIST)
    isHomePage.value = false
  }

  function openDialog(): void {
    EventBus.emit('openDialog')
  }

  function handleFileImport(event: Event): void {
    isSelecting.value = true
    isHomePage.value = true
    onFileChanged(event)
  }

  function onFileChanged(event: Event): void {
    HELPERS.showTopAlertMessage(
      true,
      'info',
      notifMessage.SUCCESS_ALERTS.SNAPSHOT_UPLOADING_HOMEPAGE,
    )
    selectedFile.value = (event.target as HTMLInputElement).files?.[0]
    if (selectedFile.value && HELPERS.hasValidExtension(selectedFile.value.name)) {
      isUploading.value = true
      uploadFile(selectedFile.value, isHomePage.value)
    } else {
      HELPERS.showTopAlertMessage(
        true,
        'error',
        notifMessage.ERROR_ALERTS.WRONG_FORMAT.FILE_NOT_SUPPORTED,
      )
    }
  }

  function buildFormatsMsg(): string {
    let formats = ''
    const allowedFilesMsg = notifMessage.ERROR_ALERTS.WRONG_FORMAT
    const allowedFilesMsgExists =
      allowedFilesMsg !== undefined &&
      Object.entries(allowedFilesMsg).length > 0 &&
      allowedFilesMsg.SINGLE_FORMAT !== undefined
    if (allowedFilesFormats.length === 1 && allowedFilesMsgExists) {
      formats = HELPERS.replaceVariableInString(
        allowedFilesMsg.SINGLE_FORMAT,
        allowedFilesFormats[0],
      )
    }

    const message = formats !== '' ? `${allowedFilesMsg.TEXT + formats}` : ''
    return message
  }
</script>

<style lang="scss" scoped>
  .itemis-analyze-headline,
  .itemis-analyze-title {
    color: rgb(var(--v-theme-font-color-headline));
  }
  .marginHomePageBlock {
    margin-top: 6em;
  }

  .center {
    text-align: center;
    margin: auto;
  }

  .margin-to-alert {
    margin-top: 1rem;
  }

  div#content {
    overflow: hidden;
  }

  a {
    text-decoration: none;
  }

  .v-main__wrap {
    background-color: rgb(var(--v-theme-background));
  }
</style>
